import { useEffect, useRef, useState, useMemo } from 'react';
import './reviewBookSumm.css';
import { ReactComponent as Chevron } from '../../../../assets/icons/trvto_downArrow.svg';
import {
    getAmount,
    getHikedPrice,
    getTaxAmount,
    getTransationCharges
} from '../../../../utils/getAmountWithTransaction';
import offerApplyTrip from '../../../tripDetails/tripBookingTab/tripBookingTabFun/offerApplyTrip';
import { toast } from 'react-toastify';
import Remove from '../../../../assets/icons/trvto_close-rounded.svg';
import { useLocation } from 'react-router-dom';
import GuidePriceSummary from '../priceSummary/GuidePriceSummary';
import ActivityPriceSummary from '../priceSummary/ActivityPriceSummary';

export default function ReviewBookSumm({
    setBookingData,
    bookingData,
    reviewConfirm,
    loggedInUser,
    setNavDetails,
    paymentType,
    setOfferType,
    handleCashOrCoins,
    selectedType,
    setSelectedType,
    amount,
    setAmount,
    cashToRedeem,
    setCashToRedeem,
    setPaymentType,
    isAuthenticated,
    handleApplyOffer,
    handleRemoveOffer
}) {
    const bookingTabRef = useRef(null);
    const location = useLocation();
    const type = location.pathname.split('/')[1];
    const [offerCode, setOfferCode] = useState('');
    const [isCashCoin, setIsCashCoin] = useState(bookingData.offerType ? true : false);
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpand = (e) => {
        setIsExpanded(!isExpanded);
    };

    const transactionCharges = useMemo(() => {
        let chargeAmount = bookingData?.amountPaid?.total;
        let remainingAmount = null;

        if (bookingData?.amountPaid?.isReserved) {
            chargeAmount = bookingData?.reserveTotal;
            remainingAmount = bookingData.amountPaid.total - bookingData.amountPaid.reserve;
        }

        setBookingData((prevState) => ({
            ...prevState,
            convinienceFee: getTransationCharges(chargeAmount),
            remainingAmount: remainingAmount
        }));
        return getTransationCharges(chargeAmount);
        //eslint-disable-next-line
    }, [bookingData.peopleAmo, bookingData.roomAmount, bookingData?.amountPaid?.actual]);

    const prev = useRef(isExpanded);

    useEffect(() => {
        // scroll only if user toggled from collapsed → expanded
        const userExpanded = !prev.current && isExpanded;

        if (userExpanded && bookingTabRef.current) {
            window.scrollTo({
                top: bookingTabRef.current.offsetTop - 100,
                behavior: 'smooth'
            });
        }

        // update prev value
        prev.current = isExpanded;
    }, [isExpanded]);

    useEffect(() => {
        const alreadyApplied = localStorage.getItem('paymentTypeChange');
        if (alreadyApplied === 'true') return;
        const chargeAmount = bookingData.amountPaid.isReserved
            ? bookingData.reserveTotal
            : bookingData?.amountPaid?.total;
        const charges = getTransationCharges(chargeAmount);
        const total = paymentType === 'UPI' ? bookingData.totalAmo - charges : bookingData.totalAmo + charges;
        setBookingData((prev) => ({
            ...prev,
            convinienceFee: charges,
            totalAmo: total
        }));
        localStorage.setItem('bookedData', null);
        localStorage.setItem('paymentType', paymentType);
        localStorage.setItem('paymentTypeChange', 'true');
        // eslint-disable-next-line
    }, [paymentType]);

    // useEffect(() => {
    //     if (cashToRedeem > 0) {
    //         baseAmountRef.current -= Math.round(cashToRedeem);
    //         return;
    //     }
    //     if (Object.keys(offerData).length === 0) return;
    //     // if (Number(bookingData.people) < offerData.minPeople) {
    //     //     toast.error(`Minimum ${offerData.minPeople} people required`);
    //     //     setBookingData((prevState) => ({ ...prevState, offerAmo: 0 }));
    //     //     return;
    //     // }

    //     // if (bookingData.totalAmo < offerData.min) {
    //     //     toast.error(`Minimum ${offerData.min} amount required`);
    //     //     setBookingData((prevState) => ({ ...prevState, offerAmo: 0 }));
    //     //     return;
    //     // }

    //     // const actualPrice = bookingData.actualPrice;
    //     // let calculatedOffer = (actualPrice * offerData.percentage) / 100;

    //     // calculatedOffer = Math.min(calculatedOffer, 500);
    //     baseAmountRef.current -= Math.round(offerData.offerPrice);
    //     setBookingData((prevState) => ({
    //         ...prevState,
    //         offerData: offerData,
    //         offerAmo: Math.round(offerData.offerPrice),
    //         offerApplied: true
    //     }));
    //     //eslint-disable-next-line
    // }, [offerData, cashToRedeem]);

    // useEffect(() => {
    //     if (removeCode) {
    //         baseAmountRef.current += Math.round(cashToRedeem > 0 ? cashToRedeem : offerData.offerPrice);
    //         const totalAmo = Math.round(bookingData.totalAmo + (isCashCoin ? cashToRedeem : bookingData.offerAmo));
    //         // if (bookingData.datesType === 'custom') {
    //         //     setBookingData((prevState) => {
    //         //         return {
    //         //             ...prevState,
    //         //             amountPaid: {
    //         //                 ...prevState.amountPaid,
    //         //                 offerAmount: 0
    //         //             },
    //         //             offerCode: '',
    //         //             offerData: {}
    //         //         };
    //         //     });
    //         // } else {
    //         //     setBookingData((prevState) => {
    //         //         return { ...prevState, totalAmo: totalAmo, offerCode: '', offerApplied: false, offerAmo: 0 };
    //         //     });
    //         // }
    //         setBookingData((prevState) => {
    //             return {
    //                 ...prevState,
    //                 totalAmo: totalAmo,
    //                 offerCode: '',
    //                 offerData: {},
    //                 offerApplied: false,
    //                 offerAmo: 0
    //             };
    //         });
    //         setCashToRedeem(0);
    //         setAmount(0);
    //         setSelectedType('');
    //         setRemoveCode(false);
    //         setOfferData({});
    //         toast.success('Offer removed successfully');
    //     } else {
    //         const totalAmo = Math.round(bookingData.totalAmo - (isCashCoin ? cashToRedeem : bookingData.offerAmo));
    //         // if (bookingData.datesType === 'custom') {
    //         //     setBookingData((prevState) => {
    //         //         return {
    //         //             ...prevState,
    //         //             amountPaid: {
    //         //                 ...prevState.amountPaid
    //         //             }
    //         //         };
    //         //     });
    //         // } else {
    //         //     setBookingData((prevState) => {
    //         //         return { ...prevState, totalAmo: totalAmo };
    //         //     });
    //         // }
    //         setBookingData((prevState) => {
    //             return { ...prevState, totalAmo: totalAmo };
    //         });
    //     }

    //     //eslint-disable-next-line
    // }, [bookingData.offerAmo, removeCode, bookingData?.amountPaid?.offerAmount, cashToRedeem, isCashCoin]);

    // useEffect(() => {
    //     const totalAmo = getAmount(paymentType, bookingData.amountPaid.total);
    //     setBookingData((prevState) => {
    //         return {
    //             ...prevState,
    //             amountPaid: {
    //                 ...prevState.amountPaid,
    //                 total: totalAmo
    //             }
    //         };
    //     });
    //     //eslint-disable-next-line
    // }, [paymentType]);

    function handlePromoCode(e) {
        const capOffer = e.target.value.toUpperCase();
        setOfferCode(capOffer);
    }

    const resetOffers = () => {
        setOfferCode('');
        setIsCashCoin(false);
        setCashToRedeem(0);
        setAmount(0);
        setSelectedType('');

        setBookingData((prev) => ({
            ...prev,
            offerCode: '',
            offerData: {},
            offerApplied: false,
            offerAmo: 0,
            selectedType: null,
            offerType: null
        }));
    };

    const handleCoinCashOffer = (event) => {
        if (bookingData.datesType === 'fixed') {
            if (bookingData?.isReserved || bookingData.isInstallment) {
                toast.warning('Offer can be applied only for full payment');
                return;
            }
        } else if (bookingData.amountPaid.isReserved || bookingData.amountPaid.isInstallment) {
            toast.warning('Offer can be applied only for full payment');
            return;
        }
        const checked = event.target.checked;
        if (!checked) {
            setBookingData((prevState) => {
                return {
                    ...prevState,
                    totalAmo: bookingData.totalAmo + cashToRedeem
                };
            });
        }
        setCashToRedeem(0);
        setIsCashCoin(checked);
        setSelectedType('');
        setAmount(0);
    };

    // const customTotalAmount =
    //     bookingData?.totalCustomAmountBeforeDiscount -
    //     bookingData?.customDiscountAmount +
    //     Math.round(bookingData?.totalCustomAmount * 0.05);

    return (
        <div ref={bookingTabRef} className={`tripBookingTab ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <div className='tripBookingPriceDiv'>
                <div className='toggleOverlay' onClick={toggleExpand} />
                <div className='internalFlex'>
                    <h2 className='reviewBoSumH1'>Price Summary</h2>
                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>₹{bookingData?.totalAmo || bookingData.totalCustomAmount}</p>
                    </div>
                </div>
                <button onClick={toggleExpand} className='collapseArrow'>
                    <Chevron width={24} height={24} />
                </button>
                <button className='reviewButton reviewBoSumSmallConfirm' type='button' onClick={reviewConfirm}>
                    Confirm
                </button>
            </div>

            <div className='tripBookingSubTab'>
                {/* {bookingData.amountPaid.isReserved && bookingData.amountPaid.isInstallment ? (
                    <></>
                ) : (
                    !isCashCoin && (
                        <>
                            <label className='tripBookDatalabel2'>Offer Code</label>
                            <div className='tripBookOfferDiv' style={{ marginBottom: '10px' }}>
                                <input
                                    type='text'
                                    placeholder='Enter promo code'
                                    name='offerCode'
                                    value={offerCode}
                                    className='tripBookOfferIn'
                                    onChange={(e) => handlePromoCode(e)}
                                />
                                <button
                                    className='tripBookOfferBtn'
                                    onClick={() => {
                                        offerApplyTrip(
                                            offerCode,
                                            handleApplyOffer,
                                            setBookingData,
                                            bookingData,
                                            setOfferType,
                                            isAuthenticated
                                        );
                                    }}
                                >
                                    Apply
                                </button>
                            </div>
                            {bookingData?.offerCode && (
                                <div
                                    className='tripBookTotalDiv'
                                    style={{
                                        marginBottom: '-10px',
                                        marginTop: '-10px',
                                        paddingRight: '8px',
                                        paddingLeft: '8px'
                                    }}
                                >
                                    <p className='tripBookTotalText'>{bookingData?.offerCode}</p>
                                    <p
                                        className='tripBookTotalText'
                                        style={{ color: 'white', cursor: 'pointer' }}
                                        onClick={() => {
                                            handleRemoveOffer();
                                        }}
                                    >
                                        <img src={Remove} alt='remove'></img>
                                    </p>
                                </div>
                            )}
                        </>
                    )
                )}
                {!bookingData.offerApplied && !isCashCoin && (
                    <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '-6px' }}>or</div>
                )}
                {!bookingData.offerApplied && (
                    <>
                        <div id='org-checkbox-div' style={{ marginTop: '5px', marginLeft: '-5px' }}>
                            <input type='checkbox' id='coinCash' checked={isCashCoin} onChange={handleCoinCashOffer} />
                            <label
                                htmlFor='coinCash'
                                id='tripReserveLabel'
                                style={{ fontWeight: '500', paddingTop: '7px' }}
                            >
                                Use coins or cash
                            </label>
                        </div>
                        {isCashCoin && (
                            <>
                                <div className='paymentTypeWrapper'>
                                    <div className='paymentTypeDiv'>
                                        <input
                                            type='radio'
                                            name='offerType'
                                            value='cash'
                                            checked={selectedType === 'cash'}
                                            onChange={(e) => {
                                                setSelectedType(e.target.value);
                                                setAmount(0);
                                            }}
                                            disabled={bookingData.offerAmo > 0}
                                        />

                                        <label className='tripBookPaymentType'>
                                            Cash : {loggedInUser?.rewards?.[1]?.count || 0}
                                        </label>
                                    </div>

                                    <div className='paymentTypeDiv'>
                                        <input
                                            type='radio'
                                            name='offerType'
                                            value='coins'
                                            checked={selectedType === 'coins'}
                                            onChange={(e) => {
                                                setSelectedType(e.target.value);
                                                setAmount(0);
                                            }}
                                            disabled={bookingData.offerAmo > 0}
                                        />
                                        <label className='tripBookPaymentType'>
                                            Coins : {loggedInUser?.rewards?.[0]?.count || 0}
                                        </label>
                                    </div>
                                </div>
                                {bookingData.offerAmo > 0 ? (
                                    <div
                                        className='tripBookTotalDiv'
                                        style={{
                                            marginBottom: '-10px',
                                            marginTop: '-10px',
                                            paddingRight: '8px',
                                            paddingLeft: '8px'
                                        }}
                                    >
                                        <p className='tripBookTotalText'>
                                            {bookingData.offerAmo} {selectedType} redeemed
                                        </p>
                                        <p
                                            className='tripBookTotalText'
                                            style={{ color: 'white', cursor: 'pointer' }}
                                            onClick={() => {
                                                handleRemoveOffer();
                                            }}
                                        >
                                            <img src={Remove} alt='remove'></img>
                                        </p>
                                    </div>
                                ) : (
                                    <div className='tripBookOfferDiv' style={{ marginBottom: '10px' }}>
                                        <input
                                            type='number'
                                            min='0'
                                            className='tripBookOfferIn'
                                            value={amount}
                                            placeholder='Enter coins or cash to redeem'
                                            onChange={(e) => {
                                                const value = Number(e.target.value);

                                                if (!selectedType) {
                                                    toast.warning('Please select coins or cash first.');
                                                    return;
                                                }

                                                // Get reward index & max allowed value
                                                const rewardIndex = selectedType === 'cash' ? 1 : 0;
                                                const maxValue = loggedInUser?.rewards?.[rewardIndex]?.count ?? 0;

                                                // Validate input
                                                if (isNaN(value) || value < 0) {
                                                    toast.warning('Enter a valid positive number.');
                                                    return;
                                                }

                                                // Prevent typing above max, just show a warning
                                                if (value > maxValue) {
                                                    toast.warning(`You can use up to ${maxValue} ${selectedType}.`);
                                                    return;
                                                }

                                                // Remove leading zeros and update normally
                                                const cleanValue = value === '' ? '' : String(Number(value));
                                                setAmount(cleanValue);
                                            }}
                                        />

                                        <button
                                            className='tripBookOfferBtn'
                                            onClick={() => {
                                                handleCashOrCoins();
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )} */}
                {type === 'gu' ? (
                    <GuidePriceSummary
                        bookingData={bookingData}
                        transactionCharges={transactionCharges}
                        paymentType={paymentType}
                        resetOffers={resetOffers}
                        setNavDetails={setNavDetails}
                    />
                ) : (
                    <ActivityPriceSummary
                        bookingData={bookingData}
                        transactionCharges={transactionCharges}
                        paymentType={paymentType}
                        getHikedPrice={getHikedPrice}
                        resetOffers={resetOffers}
                        setNavDetails={setNavDetails}
                    />
                )}
                <div>
                    {bookingData.remainingAmount > 0 && (
                        <div className='leftAmountDiv'>
                            Remaining amount to be paid on the trip Rs.
                            {bookingData.amountPaid.total - bookingData?.amountPaid.reserve * bookingData?.people}{' '}
                            (including tax)
                        </div>
                    )}
                    {!bookingData.isReserved && !bookingData?.amountPaid?.isReserved && !bookingData?.isInstallment && (
                        <div className='leftAmountDiv'>
                            You will get{' '}
                            {Math.round(
                                (bookingData.actualPrice * bookingData.people + bookingData.roomAmount) * 0.1
                            ) || Math.round(bookingData?.amountPaid?.actual * 0.1)}{' '}
                            coins after this trip{' '}
                        </div>
                    )}
                    <p className='tripBookPriceText'>Choose Payment Type</p>
                    <div className='paymentTypeWrapper'>
                        <div className='paymentTypeDiv'>
                            <input
                                type='radio'
                                name='paymentType'
                                id='upi'
                                value='UPI'
                                checked={paymentType === 'UPI'}
                                onChange={(e) => {
                                    localStorage.setItem('paymentTypeChange', 'false');
                                    setPaymentType(e.target.value);
                                    setBookingData((prev) => ({
                                        ...prev,
                                        paymentType: e.target.value
                                    }));
                                }}
                            />
                            <label htmlFor='upi' className='tripBookPaymentType'>
                                UPI
                            </label>
                        </div>
                        <div className='paymentTypeDiv'>
                            <input
                                type='radio'
                                name='paymentType'
                                id='others'
                                value='OTHERS'
                                checked={paymentType === 'OTHERS'}
                                onChange={(e) => {
                                    localStorage.setItem('paymentTypeChange', 'false');
                                    setPaymentType(e.target.value);
                                    setBookingData((prev) => ({
                                        ...prev,
                                        paymentType: e.target.value
                                    }));
                                }}
                            />
                            <label htmlFor='others' className='tripBookPaymentType'>
                                Others
                            </label>
                        </div>
                    </div>
                    {paymentType === 'UPI' && (
                        <span className='reviewBoSumCondition'>*UPI Offers - Save up to ₹1000</span>
                    )}
                </div>
                <div className='tripBookBtnDiv'>
                    <p className='reviewBoSumCondition'>
                        By clicking on the Confirm button, You accept our{' '}
                        <a href='/terms' target='_blank' rel='noopener noreferrer'>
                            Terms & Conditions
                        </a>
                        ,{' '}
                        <a href='/cancellation-policy' target='_blank' rel='noopener noreferrer'>
                            Cancellation Policy
                        </a>
                        , and{' '}
                        <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>
                            Privacy Policy
                        </a>
                    </p>

                    <button className='reviewButton reviewBoSumConfirm' type='button' onClick={reviewConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}
